/* eslint-disable no-console */
import { search } from '@nn/psdl-utility/src/location';

export const changeInput = (input, text) => {
  input.element.value = text;
  input.trigger('input');
  input.trigger('blur');
};

export const changeSelect = (select, value) => {
  select.element.value = value;
  select.trigger('change');
};

export const makeUrlParams = (params) => {
  return decodeURIComponent(Object.keys(params).map((key) => {
    if (params[key]) {
      return key + '=' + params[key]
    }
  }).filter(Boolean).join('&'));
};

export const getQueryParam = (param) => {
  const rx = new RegExp("[?&]" + param + "=([^&]+).*$");
  const returnVal = search().match(rx);
  return returnVal === null ? "" : decodeURIComponent(returnVal[1].replace(/\+/g, " "));
}

export function clearSessionStorage() {
  if (window.sessionStorage.getItem('authId')) {
    sessionStorage.removeItem('authId');
    sessionStorage.removeItem('callbacks');
  }
}
